import {Table} from '@/web-components';
import React from 'react';
import Util from '../../../forecast-app/shared/util/util';
import {useIntl} from 'react-intl';
import {Tooltip} from '@forecast-it/design-system';
import {TooltipFormulaRenderer} from '../../TooltipFormulaRenderer';

export const CurrencyColumn = ({
	value,
	currency,
	tooltip,
	hasLowerWinChance = false,
	lowerWinChanceTooltip,
	showGenericWinProbabilityTooltip,
	showZero = false,
	greyedOut = false,
	usePadding = true,
}) => {
	const intl = useIntl();
	const currencySymbol = Util.GetCurrencySymbol(currency);
	let valuePostfix = '';
	let tooltipText = tooltip ?? null;
	if (hasLowerWinChance) {
		showZero = true;
		valuePostfix = '*';
		tooltipText = lowerWinChanceTooltip;
	}

	if (showGenericWinProbabilityTooltip) {
		valuePostfix = '*';
		tooltipText = tooltip;
	}
	if (showZero && isNaN(value)) {
		value = 0;
	}
	const renderValue = (value, showZero) => {
		if (typeof value === 'string') {
			return value;
		} else if (!isNaN(value) && (value || showZero)) {
			return Util.getFormattedNumberWithCurrency(currencySymbol, value, intl);
		} else {
			return '–';
		}
	};

	const content = renderValue(value, showZero) + valuePostfix;

	return (
		<Table.Column align={'right'} usePadding={usePadding} negative={value < 0} greyedOut={greyedOut}>
			{tooltipText ? (
				<Tooltip width={'m'} content={<TooltipFormulaRenderer items={tooltipText} />} interactable={false}>
					{content}
				</Tooltip>
			) : (
				content
			)}
		</Table.Column>
	);
};
